<template>
  <div class="analysis_box" >
    <!-- 技术统计 -->
    <div v-if="scoreDetail.awayTeam">
      <!-- <videoLive :userLive='userLive' :info='scoreDetail'></videoLive> -->
      <scoreInfo ref="MyscoreInfo" :info="scoreDetail"></scoreInfo>
      <!-- 直播 -->
      <!-- <dialogLive :userLive='userLive' ref="dialogLive"></dialogLive> -->
    </div>
  </div>
</template>

<script>
import {
  matchDetail,
  teamLeagueRank,
  matchBeRelevanceAnchorList,
  teamHistoryConfrontation,
  teamRecentRecord,
  matchlastRelevance,
} from "@/api/scope.js";

import videoLive from "@/pages/components/lz_videoLive.vue";
// import totalScore from '@/pages/components/lz_totalScore.vue';
import scoreInfo from "@/pages/components/lz_scoreInfo.vue";
import matchResult from "@/pages/components/lz_matchResult.vue";
import trend from "@/pages/components/lz_trend.vue";
import moment from "moment";
import GlobalInfo from "@/lib/scoreSocket.js";

import Bus from '@/lib/bus.js'

export default {
  props: {
    anchorId: "",
    matchId:'',
  },
  components: {
    videoLive,
    trend,
    scoreInfo,
    matchResult,
  },
  watch:{
    matchId(oldval,newval){
      console.log('比赛id变化了',oldval,newval);
      this.initData();
    }
  },
  data() {
    return {
      HiddenScope: true,
      pageTeam: 10,
      pageShowType: 1,
      ContentInfo: "",
      tableName: ["塞", "胜", "平", "负", "得", "失", "积分", "排名", "胜率"],
      userLive: {},
      scoreDetail: {},
      historyList: [],
      nearlyList: [],
      startList: [],
      roomScopeDetails: {},
    };
  },
  created() {
    if(this.matchId){
      this.initData();
    }
    // 用$on事件来接收参数
    // Bus.$on('val', info => {
    //   console.log('接收消息比分',info)
    // })

  },
  methods: {
    fiflterScopeData(Info){
        console.log('孩子终于拿到数据了2',Info);
        switch (Info.messageType) {
          case 10001:
            console.log("比赛比分相关数据推送", Info.message, Info.message);
            this.changeScope(Info.message);
            break;
          case 10002:
            console.log("比赛相关事件", Info.message);
            this.eventAboutScope(Info.message, 1);
            break;
          case 10003:
            console.log("比赛事件(删除错误的事件)", Info.message);
            this.eventAboutScope(Info.message, 2);
            break;
          case 10004:
            console.log("比赛角球事件", Info.message);
            break;
          case 10005:
            console.log(" 球队技术统计", Info.message, this.matchId);
            this.objectTotalchange(Info.message);
            break;
          case 10006:
            console.log(" 足球比赛(亚盘/让球)指数", Info.message);
            this.objectchanges(Info.message, 1);
            break;
          case 10007:
            console.log(" 足球比赛(大小球)指数", Info.message);
            this.objectchanges(Info.message, 2);
            break;
          case 10008:
            console.log(" 足球比赛(欧赔)指数", Info.message);
            this.objectchanges(Info.message, 3);
            break;
          default:
            break;
        }
    },
    // 事件变化
    eventAboutScope(val, state) {
      console.log("赛况变化1", val, state);
      if (state == 1 && val.matchId == this.matchId) {
        // 添加
        if (val.matchEventVOList && val.matchEventVOList.length > 0) {
          this.$refs.MyscoreInfo.changeEventAdd(val.matchEventVOList);
        }
      }
      if (state == 2 && val.matchId == this.matchId) {
        // 删除
        console.log("赛况变化2", val, state);
        if (val.eventIdList && val.eventIdList.length > 0) {
          this.$refs.MyscoreInfo.changeEventDel(val.eventIdList);
        }
      }
    },
    // 比分变化
    changeScope(val) {
      // let val  = {
      //      "matchDataVO": { // 比分相关数据
      //        "awayCornerNum": 0, // 客队角球数
      //        "awayHalfCornerNum": 0, // 客队（半场）角球数
      //        "awayHalfScore": 0, // 客队（半场）比分
      //        "awayRedNum": 0, // 客队红牌数
      //        "awayScore": 1, // 客队比分
      //        "homeCornerNum": 1, // 主队角球数
      //        "homeHalfCornerNum": 0, // 主队(半场)角球数
      //        "homeHalfScore": 0, // 主队(半场)比分
      //        "homeYellowNum":0, // 主队黄牌数
      //        "awayYellowNum":0, // 客队黄牌数
      //        "homeRedNum": 0, // 主队红牌数
      //        "homeScore": 2 // 主队比分
      //      },
      //      "matchExtraVO": {// 比赛加时数据
      //         "extraScore": "", // 加时: 加时阶段比分
      //         "extraType": 0,// 加时: 加时阶段类型，1:120分钟，2：加时，3：加时中
      //         "firstKick": 0,// 加时: 先开球方，1：主队先开球，2：客队先开球
      //         "normalScore": "",// 加时: 常规时间的比分
      //         "normalTime": 0,// 加时: 常规时间
      //         "penaltyKickScore": "",// 加时: 点球大战比分
      //         "twoLegsScore": "",// 加时: 两回合总比分, 该字段仅在比赛有加时、点球的情况才更新
      //         "win": 0 // 加时: 获胜方，1：主队获胜，2：客队获胜
      //      },
      //      "matchInfoVO": {// 比赛基本信息
      //         "awayId": 49301, // 客队ID
      //         "firstHalfStartTime": 1658147334,// 上半场开始时间，单位：秒(有时候没有)
      //         "homeId": 35691,// 主队ID
      //         "matchId": 40027, // 比赛ID
      //         "state":1, // 比赛状态, -14:推迟,-13:中断,-12:腰斩,-11:待定,-10:取消,-1.完场,0:未开始,1:上半场,2:中场,3:下半场,4:加时,5:点球  ID
      //         "matchStartTime": 1658147400, // 比赛时间，单位：秒
      //         "secondHalfStartTime": 0 // 下半场开始时间，单位：秒
      //      }
      // }
      // 同一场比赛
      console.log("比分变化...1", val.matchInfoVO.matchId, this.matchId);
      if (val.matchInfoVO.matchId == this.matchId) {
        console.log("比分变化...2", val.matchInfoVO.matchId, val);
        let {
          matchDataVO: {
            awayScore,
            homeScore,
            homeYellowNum,
            awayYellowNum,
            homeRedNum,
            awayRedNum,
            homeCornerNum,
            awayCornerNum,
          },
          matchExtraVO,
          matchInfoVO: { state },
        } = val;
        this.scoreDetail.matchInfo.state = state;
        this.scoreDetail.matchExtra = matchExtraVO;
        this.scoreDetail.matchData.homeScore = homeScore;
        this.scoreDetail.matchData.awayScore = awayScore;
        this.scoreDetail.matchData.homeYellowNum = homeYellowNum;
        this.scoreDetail.matchData.awayYellowNum = awayYellowNum;
        this.scoreDetail.matchData.homeRedNum = homeRedNum;
        this.scoreDetail.matchData.awayRedNum = awayRedNum;
        this.scoreDetail.matchData.homeCornerNum = homeCornerNum;
        this.scoreDetail.matchData.awayCornerNum = awayCornerNum;
        this.$forceUpdate();
      }
    },
    // 球队技术统计变化
    objectTotalchange(val) {
      if (val.matchId == this.matchId) {
        console.log("技术统计推送", val.teamTechStatisticVOList);
        this.$refs.MyscoreInfo.fifTotal(val.teamTechStatisticVOList);
      }
    },
    // 走势变化
    objectchanges(val, state) {
      if (val.matchId == this.matchId) {
        // if(this.pageShowType == 2){
        //   this.$refs.Mytrend.objectchange(val,state)
        // }
        // 子页面走势变化
        this.$refs.MyscoreInfo.changeTreeds(val, state);
      }
    },
    // 加时赛事务处理
    addTimefif(item, val) {
      let str = "";
      if (item.normalScore != "") {
        str += `90 分钟 【${item.normalScore}】`;
      }
      if (item.twoLegsScore != "") {
        str += `  两回合 【${item.twoLegsScore}】`;
      }
      if (item.extraScore != "") {
        str += ` 120分钟 【${item.extraScore}】`;
      }
      if (item.penaltyKickScore != "") {
        str += ` 点球 【${item.penaltyKickScore}】`;
      }
      if (item.win != "") {
        let name = item.win == 1 ? val.homeTeam.nameCn : val.awayTeam.nameCn;
        str += ` ${name} 胜出`;
      }
      return str;
    },
    changeShowType(e) {
      this.pageShowType = e;
    },
    // 过滤比分
    fifscoep(val) {
      if (val.matchInfo.state < 0) {
        return "";
      }
    },
    fiftime(val) {
      return moment.unix(val).format("YYYY-MM-DD HH:mm:ss");
    },
    fifiData(val) {
      return moment.unix(val).format("YYYY-MM-DD");
    },
    initData() {
      // 指定比赛被关联的主播信息
      matchBeRelevanceAnchorList({
        matchId: this.matchId,
        matchType: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          this.userLive = res.data.data.relevanceMatchAnchorVOList;
          console.log("比赛关联的主播信息", this.userLive);
        }
      });
      this.scoreDetail = {};
      // 比赛详情
      matchDetail({
        matchId: this.matchId,
      }).then((res) => {
        if (res.data.code == 200) {
          this.scoreDetail = res.data.data;
          console.log("比赛详情数据", this.scoreDetail);
          // 打开动画
          if (this.scoreDetail.matchLiveVO.haveAnimation == 1) {
            this.$emit("change", this.scoreDetail.matchLiveVO.animationUrl);
          }
        }
      });

      // 联赛积分排名
      // teamLeagueRank({
      //   matchId: this.matchId,
      // }).then(res => {
      //   if (res.data.code == 200) {
      //     this.startList = res.data.data
      //   }
      // })

      // 历史交锋
      // teamHistoryConfrontation({
      //  matchId: this.matchId,
      //   limit: this.pageTeam,
      //   isHalf: this.sameTeam == 3 ? 1 : '',
      //   sameTeam: this.sameTeam == 1 ? 1 : '',
      //   sameLeague: this.sameTeam == 2 ? 1 : '',
      // }).then(res => {
      //   if (res.data.code == 200) {
      //     this.historyList = res.data.data
      //   }
      // })

      // 近期战绩
      // teamRecentRecord({
      //  matchId: this.matchId,
      //   limit: this.pageTeam,
      //   isHalf: this.sameTeam == 3 ? 1 : '',
      //   sameTeam: this.sameTeam == 1 ? 1 : '',
      //   sameLeague: this.sameTeam == 2 ? 1 : '',
      // }).then(res => {
      //   if (res.data.code == 200) {
      //     this.nearlyList = res.data.data
      //   }
      // })
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/style/flex.scss";

@media screen and (min-width: 1100px) {
  .analysis_box {
    // background-color: skyblue !important; /* 表示屏幕尺寸大于等于600px时，背景色变为天蓝色 */
  }
}

@media screen and (min-width: 1500px) {
  .analysis_box {
    // background-color: #f5cf8e !important;

    /deep/ .homeInfoitem {
      padding: 6px !important;
    }
    /deep/ .fenxiBox{
      width: 62.5vw !important;
      overflow-x: scroll;
    }
    /deep/ .headercenter {
      padding: 24px 2px !important;
      .circle {
        span {
          margin: 0 2px !important;
        }
      }
    }

  /deep/ .homeAwayData{
        width: 62.5vw !important;

  }
    /deep/ .scorebang {
        width: 62.5vw !important;

    }
    /deep/ .sai_databox {
        width: 62.5vw !important;

      .col_first{
        width: 100px;
      }

      .headerTop {
        flex: 2 !important;

      }
      .upstatus {
        max-width: 330px !important;
        width: 100% !important;
        min-width: 200px !important;
      }
    }
  }
}

@media screen and (min-width: 1800px) {
  .analysis_box {
    // background-color: red !important; /* 表示屏幕尺寸大于等于1200px时，背景色变为红色 */

    /deep/ .homeInfoitem {
      padding: 12px !important;
    }
    /deep/ .headercenter {
      padding: 24px 2px !important;
      .circle {
        span {
          margin: 0 12px !important;
        }
      }
    }
  }
}

.totalTxt {
  text-align: center;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  background: #ffffff;
  color: #666666;
  border-top: 1px solid rgba(0, 0, 0, 0.3);
}

.switchTabs {
  width: 70px;
  height: 20px;
  border-radius: 2px;
  display: flex;
  background-color: #eeeeee;
  position: relative;

  span {
    cursor: pointer;
    color: #333;
    width: 34px;
    text-align: center;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }

  .nearly1 {
    width: 34px;
    height: 20px;
    transition: all 0.2s;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #721edc;
    font-size: 12px;
    border-radius: 2px;
    z-index: 0;
    position: absolute;
    color: #fff !important;
    left: 0;
  }

  .nearly2 {
    width: 34px;
    z-index: 0;
    height: 20px;
    transition: all 0.2s;
    display: flex;
    justify-content: center;
    font-size: 12px;
    align-items: center;
    color: #fff !important;
    background: #721edc;
    border-radius: 2px;
    position: absolute;
    left: 50%;
  }
}

.analysis_box {
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: column;
  background: #f7f8fa;
  min-height: 100vh;

  .tablisthistory {
    display: flex;
    width: 100%;
    font-size: 14px;
    box-sizing: border-box;
    height: 45px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;

    /deep/ .el-radio {
      //添加边框
      /* border: 1px solid rgb(207, 204, 204); */
      //选中时边框的颜色
      /* &.is-checked {
                border: 1px solid #28d4c1 !important;
              } */
      //鼠标滑过改变字体和小圆圈边框的样式
      &:hover {
        border-color: #721edc !important;
        color: #721edc !important;

        //鼠标滑过时小圆点边框显示
        .el-radio__inner {
          border-color: #721edc;
        }
      }

      .el-radio__input {
        margin-bottom: px(5);

        //选中时的样式
        &.is-checked {
          .el-radio__inner {
            //选中时小圆圈的的颜色
            background-color: #721edc;
            border-color: #721edc;
          }

          + .el-radio__label {
            //选中时字体的颜色
            color: #721edc !important;
            font-size: 14px;
          }
        }

        .el-radio__inner {
          // 鼠标滑过小圆点时的样式
          &:hover {
            border-color: #721edc;
          }
        }
      }
    }
  }

  .scorebang {
    width: 1200px;
  }

  .historyData {
    width: 1200px;

    .historyItem:nth-child(2n) {
      background-color: #eeeeee;
    }

    .historyItem:nth-child(1) {
      color: #999999 !important;
    }

    .historyItem {
      background-color: #fff;
      width: 100%;
      display: flex;
      height: 40px;
      align-items: center;
      justify-content: space-around;

      div {
        text-align: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }

      .itemsblock1 {
        width: 100px;
      }

      .itemsblock2 {
        width: 200px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 0 12px;
        box-sizing: border-box;

        img {
          width: 16px;
          height: 16px;
        }
      }

      .itemsblock3 {
        width: 60px;
      }

      .itemsblock4 {
        width: 150px;
        display: flex;
        height: 50px;
        line-height: 50px;
        justify-content: center;

        span {
          display: inline-block;
          text-align: center;
          width: 50px;
        }
      }

      .itemsblock5 {
        width: 50px;
      }
    }
  }

  .moduleName {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    margin: 24px 0 12px;
  }

  .leftInfo {
    width: 594px;
    height: 202px;
    background: #ffffff;

    .title {
      flex: 1;
      padding: 0 12px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      height: 50px;
      line-height: 50px;
      text-align: left;
      display: flex;
      align-items: center;

      img {
        margin-right: 6px;
        vertical-align: middle;
        width: 20px;
        height: 20px;
      }
    }

    .tableName,
    .datainfo {
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      padding: 0 10px;

      div {
        font-size: 14px;
        text-align: center;
        width: 59px;
        height: 38px;
        line-height: 38px;
      }
    }

    .datainfo:last-child {
      border-bottom: none !important;
    }

    .datainfo {
      flex: 1;
      color: #333333;
      display: flex;
      justify-content: space-between;
    }

    .tableName {
      flex: 1;
      color: #999999;
    }
  }

  .page_top {
    max-width: 1200px;

    .livesitem {
      padding: 0 4px;
      cursor: pointer;
      margin-right: 27px;
      box-sizing: border-box;
      width: 142px;
      height: 34px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 17px;

      .headerImg {
        width: 28px;
        height: 28px;
        border-radius: 50%;
      }

      span {
        flex: 1;
        color: #eee;
        margin-left: 4px;
        line-height: 34px;
      }
    }

    .homescoreName {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      min-width: 300px;
      margin: 20px;

      img {
        margin: 0 4px;
        width: 40px;
        border-radius: 50%;
        transform: scale(1.01);
        height: 40px;
        background: #ffffff;
        border-radius: 50%;
      }
    }

    .btnTab {
      transform: translateY(-25px);
      width: 1200px;
      height: 52px;
      background: #1b933f;
      border-radius: 0px 0px 6px 6px;

      div {
        width: 160px;
        text-align: center;
        cursor: pointer;
        height: 52px;
        line-height: 52px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }

      .activeDetault {
        width: 160px;
        height: 52px;
        line-height: 50px;
        background: #0c702a;
      }
    }
    .nobegins {
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
    .header_aways {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 1200px;
      height: 260px;
      background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0.1) 0%,
        rgba(0, 0, 0, 0.4) 100%
      );
      border-radius: 6px;
      position: relative;

      .myContent {
        position: relative;
        z-index: 1;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
      }

      .addTime {
        margin-top: 12px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }

      .Scoretime {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }

      .TOPbg {
        position: absolute;
        width: 1200px;
        height: 260px;
        background: linear-gradient(
          90deg,
          rgba(0, 0, 0, 0.1) 0%,
          rgba(0, 0, 0, 0.4) 100%
        );
        border-radius: 6px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/lz_roomScope.vue